export default __webpack_public_path__ + "static/media/unit-execution-notification-2.28954cc0.mp3";